import React, { useState, useEffect } from 'react';
import ConfigureImg from '../../images/Configure.png';
import BusinessImg from '../../images/Business.png';
import DoctorImg from '../../images/Doctor.png';
const data = [
  {
    label: 'Blue collar',
    percent: 0.68,
    brand: 1.4,
    imageUrl: ConfigureImg
  },
  {
    label: 'White collar',
    percent: 0.68,
    brand: 1.4,
    imageUrl: BusinessImg
  },
  {
    label: 'Pink collar',
    percent: 0.68,
    brand: 1.4,
    imageUrl: DoctorImg
  },
]

const CampaignOccupationChart = props => (
  <div div className="CampaignDonutChart">
    <h2>Occupation</h2>
    <div className="CampaignBarChart_more-info" onClick={()=>props.closeModal(true)}>More info</div>

    <div className="CampaignBarChart_container">
    <div className="CampaignBarChart_axis-line-area" style={{height: '300px'}}>
          <div className="CampaignBarChart_x-axis-title">100%</div>
          <div className="CampaignBarChart_x-axis" style={{width: '90%'}}/>
          <div className="CampaignBarChart_x-axis-title">75%</div>
          <div className="CampaignBarChart_x-axis" style={{width: '90%'}}/>
          <div className="CampaignBarChart_x-axis-title">50%</div>
          <div className="CampaignBarChart_x-axis" style={{width: '90%'}}/>
          <div className="CampaignBarChart_x-axis-title">25%</div>
          <div className="CampaignBarChart_x-axis" style={{width: '90%'}}/>
          <div className="CampaignBarChart_x-axis-title">0%</div>
          <div className="CampaignBarChart_x-axis" style={{width: '90%'}}/>
        </div>
    </div>

    <div className="CampaignBarChart_positive-bar-area"
        style={{backgroundColor: 'transparent', width: '36%', padding: '0px 40px'}}>
          {data.map(item => (
            <div className="CampaignBarChart_positive-bar"  style={{ marginTop: '124px', background: "linear-gradient(#4651B5, #FF856D)"}} />
          ))}
    </div>

    <div className="CampaignBarChart_positive-img-area" style={{width: '37%', marginLeft: '40px', bottom: '220px' ,padding: '0px 40px' }}>
          {data.map(item => (
            <img src={item.imageUrl} />
          ))}
    </div>

    <div className="CampaignBarChart_positive-title-area" style={{width: '40%', marginLeft: '18px', bottom: '115px' ,padding: '0px 40px' }} >
          {data.map(item => (
            <div style={{display:'flex',  flexDirection: 'column'}}>
            <div className="CampaignBarChart_positive-titles" style={{  transform: 'rotate(0deg)', width: '100%',fontSize: '14px'}}>
              {item.label}
            </div>
            <div style={{color: '#080045', fontSize: '14px'}}>
                {`${item.percent *100}%`} | {item.brand}x
            </div>
            </div>
          ))}
    </div>

    <div className="CampaignBarChart_background-area" />


  </div>
);

export default CampaignOccupationChart;
